import React, { Component } from 'react';
import PropTypes from 'prop-types';

import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import {
	Card,
	CardHeader,
	CardBody,
	Form,
	FormGroup,
	FormFeedback,
	FormText,
	Label,
	Input,
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Col,
	Row,
	Container,
} from 'reactstrap';

import PrettyCheckbox from '../Common/PrettyCheckbox';
import InputCNPJ from '../Common/InputCNPJ';

import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import './EmpresasCadastro.scss';

const isSimulacao = localStorage.getItem('isSimulacao') === 'true';

class EmpresasCadastro extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOnUpdate: false,
			formData: {
				idUsuario: localStorage.getItem('CodUsuario'),
				cnpj: '',
				razaoSocial: '',
				principal: false,
				usarCertificadoEconet: true,
			},
			invalid: {
				cnpj: false,
				razaoSocial: false,
			},
			backdrop: true,
			isOpen: false,
			validarFormulario: false,
			exibirRetorno: false,
		};
	}

	handleReset = () => {
		setImmediate(() => this.holdAlerts(false));
		this.setState({
			isOnUpdate: false,
			formData: {
				idUsuario: localStorage.getItem('CodUsuario'),
				cnpj: '',
				razaoSocial: '',
				principal: false,
				usarCertificadoEconet: true,
			},
			invalid: {
				cnpj: false,
				razaoSocial: false,
			},
		});
	};

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
		this.handleReset();
	};

	getSnapshotBeforeUpdate = (prevProps, prevState) => !prevState.isOpen && this.state.isOpen;

	componentDidUpdate(prevProps, prevState, isModalOpening) {
		if (isModalOpening && this.props.dataOnUpdate) {
			this.setState({
				isOnUpdate: true,
				formData: { ...this.props.dataOnUpdate, idUsuario: localStorage.getItem('CodUsuario') },
			});
		}
	}

	handleClosed = () => {
		this.handleReset(false);
		if (typeof this.props.onClosed === 'function') this.props.onClosed();
	};

	handleCNPJBlur = invalid => {
		this.setState({ invalid: { ...this.state.invalid, cnpj: invalid } });
	};

	handleInputBlur = ({ target }) => {
		this.setState({
			invalid: {
				...this.state.invalid,
				[target.name]: (target.required && !this.state.formData[target.name]) || !target.validity.valid,
			},
		});
	};

	handleInputChange = ({ target }) => {
		var value = target.value;

		switch (target.type) {
			case 'checkbox':
				value = target.checked;
				break;
			case 'radio':
				value = target.value === 'true';
				break;
			default:
				value = target.value;
				break;
		}
		const field = target.name;

		this.setState({
			formData: { ...this.state.formData, [field]: value },
			invalid: { ...this.state.invalid, [field]: (target.required && !value) || !target.validity.valid },
		});
	};

	handleChangeFile = evt => {
		var self = this;
		var reader = new FileReader();
		var file = evt[0];

		reader.onload = function(upload) {
			var formData = { ...self.state.formData };
			formData.certificado = upload.target.result;
			formData.certificadoNome = file.name;
			formData.trocouCertificado = true;
			self.setState({ formData });
		};

		reader.readAsDataURL(file);
	};

	isFormValid = () => Object.values(this.state.invalid).every(v => v === false);

	handleSubmit = e => {
		if (this.isFormValid()) {
			this.onLoading(true);
			HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}Empresa/Salvar`, this.state.formData)
				.then(response => {
					this.onLoading(false);
					const { data } = response;
					if (!data.error) {
						this.showSuccessMessage('Empresa salva com sucesso');
						if (this.state.isOnUpdate && typeof this.props.onDataUpdated === 'function') {
							this.props.onDataUpdated();
						} else if (typeof this.props.onDataCreated === 'function') {
							this.props.onDataCreated();
						}
						this.closeModal();
					} else {
						this.holdAlerts(true);
						this.showErrorMessage(data.mensagem);
					}
				})
				.catch(() => {
					this.onLoading(false);
					this.holdAlerts(true);
					this.showErrorMessage('Ocorreu um erro inesperado ao salvar a empresa');
				});
		} else {
			this.showWarningMessage('Formulário incompleto.');
		}
		e.preventDefault();
	};

	removerCertificado = () => {
		var formData = { ...this.state.formData };
		formData.certificadoNome = '';
		formData.trocouCertificado = true;
		this.setState({ formData });
	};

	render() {
		return (
			<Modal
				size="lg"
				id="modalEmpresasCadastro"
				centered={true}
				isOpen={this.state.isOpen}
				onClosed={this.handleClosed}
				backdrop="static">
				<AlertasContext.Consumer>
					{alertas => {
						this.showInfoMessage = alertas.info;
						this.showSuccessMessage = alertas.success;
						this.showWarningMessage = alertas.warning;
						this.showErrorMessage = alertas.error;
						this.holdAlerts = alertas.setHoldState;
					}}
				</AlertasContext.Consumer>
				<BlockUiContext.Consumer>
					{blockUi => {
						this.onLoading = blockUi.handleLoading;
					}}
				</BlockUiContext.Consumer>
				<Form onSubmit={this.handleSubmit}>
					<ModalHeader>Cadastro de empresa</ModalHeader>
					<ModalBody>
						<Row>
							<Col>
								<Card className="border-light">
									<CardHeader>
										<i className="ecoico ecoico-cadastro-empresas" /> Dados da empresa
									</CardHeader>
									<CardBody>
										<FormGroup row>
											<Col>
												<Label for="razaoSocial">
													Razão Social / Nome <span>*</span>
												</Label>
												<Input
													value={this.state.formData.razaoSocial}
													type="text"
													id="razaoSocial"
													name="razaoSocial"
													maxLength="200"
													required
													onBlur={this.handleInputBlur}
													onChange={this.handleInputChange}
													invalid={this.state.invalid.razaoSocial}
												/>
												<FormFeedback>Digite a razão social</FormFeedback>
												<FormText className="d-flex justify-content-end">
													<span>*</span> Campo obrigatório
												</FormText>
											</Col>
											<Col>
												<Label for="cnpj">
													CNPJ <span>*</span>
												</Label>
												<InputCNPJ
													value={this.state.formData.cnpj}
													required
													onBlur={this.handleInputBlur}
													onChange={this.handleInputChange}
													invalid={this.state.invalid.cnpj}
												/>
												<FormFeedback>
													{this.state.formData.cnpj ? 'CNPJ inválido' : 'Digite o CNPJ'}
												</FormFeedback>
											</Col>
											<Col>
												<Label for="principal">Esta é a empresa principal?</Label>
												<div className="switch">
													<PrettyCheckbox
														strTitle={
															this.state.formData.principal
																? 'Remover principal'
																: 'Configurar como principal'
														}
														checked={this.state.formData.principal}
														id="principal"
														onChange={this.handleInputChange}
														labelSuccess="Sim"
														labelDanger="Não"
													/>
													<FormFeedback>Digite a razão social</FormFeedback>
													<FormText>
														Esta opção permite que o certificado cadastrado aqui seja
														utilizado para ações de outras empresas que não possuem um
														certificado próprio.
													</FormText>
												</div>
											</Col>
										</FormGroup>
									</CardBody>
								</Card>
							</Col>
						</Row>
						<Row>
							<Col>
								<Card className="border-light card-certificado">
									<CardHeader>
										<i className="ecoico ecoico-cadastro-certificados" />
										Certificado digital
									</CardHeader>
									<CardBody>
										<Row>
											<Col>
												<FormGroup row>
													<legend>Qual certificado deseja utilizar?</legend>
													<Col xs="5">
														<FormGroup
															className={`form-certificado ${
																this.state.formData.usarCertificadoEconet ? 'ativo' : ''
															}`}>
															<PrettyCheckbox
																prettyRadio
																value="true"
																iconOn="ecoico ecoico-certificado-econet-on"
																iconOff="ecoico ecoico-certificado-econet-off"
																labelDefault="Econet"
																id="usarCertificadoEconet"
																onChange={this.handleInputChange}
																checked={this.state.formData.usarCertificadoEconet}
															/>
														</FormGroup>
													</Col>
													<Col xs="5">
														<FormGroup
															className={`form-certificado meu ${
																!this.state.formData.usarCertificadoEconet
																	? 'ativo'
																	: ''
															}`}>
															<PrettyCheckbox
																prettyRadio
																value="false"
																iconOn="ecoico ecoico-certificado-empresa-on"
																iconOff="ecoico ecoico-certificado-empresa-off"
																labelDefault="Meu certificado"
																id="usarCertificadoEconet"
																onChange={this.handleInputChange}
																checked={!this.state.formData.usarCertificadoEconet}
															/>
														</FormGroup>
													</Col>
												</FormGroup>
												<div className="div-ou">OU</div>
											</Col>
											<Col xs="5">
												{!this.state.formData.usarCertificadoEconet ? (
													<div id="cert-empresa-selected">
														{this.state.formData.certificadoNome ? (
															<div>
																<h3>Certificado digital enviado</h3>
																<label>{this.state.formData.certificadoNome}</label>
																<button
																	type="button"
																	className="close"
																	aria-label="Close"
																	onClick={() => this.removerCertificado()}>
																	<span aria-hidden="true">&times;</span>
																</button>
															</div>
														) : (
															<div>
																<h3>Envie seu certificado digital</h3>
																<FormGroup>
																	<Input
																		type="file"
																		name="file"
																		id="exampleFile"
																		onChange={e => {
																			this.handleChangeFile(e.target.files);
																		}}
																	/>
																</FormGroup>
															</div>
														)}

														<FormGroup>
															<Label for="razaoSocial">Senha certificado</Label>
															<Input
																value={this.state.formData.certificadoSenha}
																type="password"
																id="certificadoSenha"
																name="certificadoSenha"
																maxLength="50"
																onBlur={this.handleInputBlur}
																onChange={this.handleInputChange}
																invalid={this.state.invalid.certificadoSenha || ''}
																placeholder="Senha do certificado"
															/>
														</FormGroup>
													</div>
												) : (
													<div id="cert-econet-selected">
														<h3>O Certificado Digital Econet foi selecionado.</h3>
														<p>
															Todas as acções utilizarão este certificado para validação.
														</p>
														<p>Você pode alterar esse certificado quando quiser.</p>
													</div>
												)}
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</ModalBody>
					<ModalFooter>
						<Container>
							<Row className="justify-content-end">
								<Col xs="auto">
									<Button block onClick={() => this.closeModal()} color="info">
										Cancelar cadastro
									</Button>
								</Col>
								<Col xs="2">
									<Button block type="submit" color="primary" disabled={isSimulacao ? true : false}>
										Salvar
									</Button>
								</Col>
							</Row>
						</Container>
					</ModalFooter>
				</Form>
			</Modal>
		);
	}
}

EmpresasCadastro.propTypes = {
	dataOnUpdate: PropTypes.array,
	onClosed: PropTypes.func,
	onDataUpdated: PropTypes.func,
	onDataCreated: PropTypes.func,
};

export default EmpresasCadastro;
